/**
 * Easyblocks Components Index
 * Export all components for registration with Easyblocks
 */

// Layout / primitives-ish
import { RootLayoutSections } from "./RootLayoutSections";
import { ButtonLink } from "./primitives/ButtonLink";
import { DocumentLink } from "./primitives/DocumentLink";
import { HeadingBlock } from "./primitives/HeadingBlock";
import { ImageBlock } from "./primitives/ImageBlock";
import { QuillText } from "./primitives/quill-text-editor";

// Components
import { AccordionItem } from "./ui/AccordionItem";
import { Card } from "./ui/Card";
import { NewsCard } from "./external-data/NewsCard";
import { EventCard } from "./external-data/EventCard";
import { RosterAccordion } from "./external-data/RosterAccordion";
import { NeighborhoodsAccordion } from "./external-data/NeighborhoodsAccordion";
import { ResidentDirectorySection } from "./external-data/ResidentDirectorySection";
import { DocumentsAccordion } from "./external-data/DocumentsAccordion";
import { ListTemplateSection } from "./external-data/ListTemplateSection";

// Sections
import { HeroSection } from "./sections/HeroSection";
import { HeroImageSection } from "./sections/HeroImageSection";
import { VideoEmbedSection } from "./sections/VideoEmbedSection";
import { CTASection } from "./sections/CtaSection";
import { SingleColumn } from "./sections/SingleColumn";
import { AccordionSection } from "./sections/AccordionSection";
import { GridSection } from "./sections/GridSection";
import { CardsSection } from "./sections/CardsSection";
import { ColumnsSection } from "./sections/ColumnsSection";
import { PhotoAlbum } from "./sections/PhotoAlbum";
import { NewsLatestRow } from "./external-data/NewsLatestRow";
import { EventsRow } from "./external-data/EventsRow";

// Re-export all
export {
  RootLayoutSections,
  QuillText,
  HeadingBlock,
  Card,
  NewsCard,
  NewsLatestRow,
  EventCard,
  EventsRow,
  RosterAccordion,
  NeighborhoodsAccordion,
  ResidentDirectorySection,
  DocumentsAccordion,
  ListTemplateSection,
  ButtonLink,
  DocumentLink,
  ImageBlock,
  HeroSection,
  HeroImageSection,
  VideoEmbedSection,
  CTASection,
  SingleColumn,
  GridSection,
  CardsSection,
  ColumnsSection,
  AccordionSection,
  AccordionItem,
  PhotoAlbum,
};

// Components map for Easyblocks registration
export const easyblocksComponents = {
  RootLayoutSections,
  QuillText,
  HeadingBlock,
  Card,
  NewsCard,
  NewsLatestRow,
  EventCard,
  EventsRow,
  RosterAccordion,
  NeighborhoodsAccordion,
  ResidentDirectorySection,
  DocumentsAccordion,
  ListTemplateSection,
  ButtonLink,
  DocumentLink,
  ImageBlock,
  HeroSection,
  HeroImageSection,
  VideoEmbedSection,
  CTASection,
  SingleColumn,
  GridSection,
  CardsSection,
  ColumnsSection,
  AccordionSection,
  AccordionItem,
  PhotoAlbum,
};

export default easyblocksComponents;


